<template>
  <div class="drawpop">
    <span class="mask"></span>
    <Svgaplayer
      :loops="0"
      class="guang"
      src="https://yun.duiba.com.cn/polaris/%E6%8A%BD%E5%8D%A1%E5%BC%B9%E7%AA%97%E7%AD%89%E6%B0%9B%E5%9B%B4%E5%85%89%E6%95%88.020499dbadc56794bbb287365aae72dbe38d0f18.svga"
    >
    </Svgaplayer>

    <div :class="`boxContent ${boxContentClass}`" ref="boxContent">
      <div class="card_back"></div>
      <div
        class="card_front"
        :style="{ backgroundImage: `url(${cardFrontImg})` }"
      ></div>
    </div>
  </div>
</template>

<script>
import Svgaplayer from "../SvgaPlayer/index.vue";
export default {
  name: "DrawPop",
  props: ["handleClose", "cardType", "cardDataList"],
  data: () => {
    return {
      boxContentClass: "",
    };
  },
  computed: {
    cardFrontImg() {
      return this.getImgById(this.cardType);
    },
  },
  components: {
    Svgaplayer,
  },

  methods: {
    getImgById(cardType) {
      const target = this.cardDataList.find((val) => val.cardType === cardType);
      if (target !== null) {
        return target && target.cardUrl;
      } else {
        return null;
      }
    },
    getIndexById(cardType) {

       return this.cardDataList.findIndex((val) => val.cardType === cardType);
    },
    onPopEnd() {
      // 弹窗动效结束后回调
      const cardIndex = this.getIndexById(this.cardType);

      if (cardIndex < 0) {
        console.error("cardType没有匹配上，注意配置");
        return;
      }
      setTimeout(() => {
        this.boxContentClass = "scaleClass";
        let y = -2.6 + 1 * (cardIndex < 4 ? cardIndex : cardIndex - 4);
        let x = cardIndex > 3 ? 2.8 : 1.5;
        this.$refs.boxContent.style = `--ty:${y}rem;--tx:${x}rem`;
        setTimeout(() => {
          // 缩放结束后回调
          this.$emit("handleClose");
        }, 1300);
      }, 2500);
    },
  },
  mounted() {
    this.onPopEnd();
  },
};
</script>

<style scoped lang="less">
@import "../../res.less";

.drawpop {
  width: 7.5rem;
  height: 16.24rem;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%) translateZ(100px);

  .mask {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgb(0, 0, 0);
    opacity: 0.7;
    position: absolute;
  }

  .boxContent {
    width: 4.3rem;
    height: 6.12rem;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-style: preserve-3d;
    perspective: 10rem;
    animation: card_transform 1.5s both;

    .card_back {
      width: 100%;
      height: 100%;
      // position: absolute;
      transform: translateZ(1px);
      .sparkBg("DrawPop/cardfrnt.png");
    }

    .card_front {
      width: 100%;
      height: 100%;
      margin-top: -6.12rem;
      transform: translateZ(-1px) rotateY(180deg);

      // position: absolute;
      .sparkBg("HomePage/card1.png");
    }
  }

  .guang {
    width: 7.5rem;
    height: 14.08rem;
    position: absolute;
    top: 45%;
    left: 50%;
    transform:  translateZ(-100px) translate(-50%, -50%);
  }

  .scaleClass {
    // --ty:-2.6rem;
    // --tx:1.6rem;
    animation: move_cardScale 1.2s both;
  }

  @keyframes card_transform {
    0% {
      transform: translate(-50%, -50%) rotateY(0deg);
    }

    100% {
      transform: translate(-50%, -50%) rotateY(900deg);
    }
  }

  @keyframes move_cardScale {
    0% {
      transform: translate(-50%, -50%) scale(1) rotateY(900deg);
    }

    100% {
      transform: translate(var(--ty), var(--tx)) scale(0) rotateY(900deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DrawPop/index.vue